module.exports = __webpack_public_path__ + "static/media/visibility.57fbdd06.svg";